import { atom } from 'nanostores'

export const $isRulesDialogOpen = atom<boolean>(false)

export const openRulesDialog = () => {
  $isRulesDialogOpen.set(true)
}

export const closeRulesDialog = () => {
  $isRulesDialogOpen.set(false)
}
